import { createContext } from "react";

export const ThemeContext = createContext({
	phoneCtaText: "Call Now",
});
